import React from 'react';
import { observer } from 'mobx-react';

import { formatDueDate } from 'utils/date';

import { colors } from 'theme/colors';

import { DueDateParagraph } from './styles';

interface TaskListCellDueDateProps {
  dueDate: string | null;
}

const TaskListCellDueDate: React.FunctionComponent<TaskListCellDueDateProps> = ({ dueDate }) => {
  if (dueDate === undefined || dueDate === null) {
    return <DueDateParagraph color={colors.text.secondary}>No Due Date</DueDateParagraph>;
  }

  const { name, color } = formatDueDate(dueDate);
  return <DueDateParagraph color={color}>{name}</DueDateParagraph>;
};

export default observer(TaskListCellDueDate);
